<template>
  <div class="empty-state">
    <div class="empty-icon">
      <i :class="icon" aria-hidden="true"></i>
    </div>
    <div class="empty-text">{{ title }}</div>
    <div v-if="hint" class="empty-hint">{{ hint }}</div>
    <div v-if="$slots.action" class="empty-action">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    icon: { type: String, default: 'el-icon-search' },
    title: { type: String, required: true },
    hint: { type: String, default: '' }
  }
}
</script>

<style scoped>
.empty-state {
  text-align: center;
  padding: var(--space-3xl);
  background: var(--color-surface);
  border: 2px dashed var(--color-border);
  border-radius: var(--radius-lg);
}
.empty-icon {
  width: 72px;
  height: 72px;
  border-radius: var(--radius-full);
  background: var(--color-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto var(--space-lg);
  font-size: 32px;
  color: var(--color-text-muted);
}
.empty-text {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: var(--space-sm);
}
.empty-hint {
  font-size: 13px;
  color: var(--color-text-secondary);
}
.empty-action {
  margin-top: var(--space-lg);
}
</style>
